;(function() {

	document.addEventSelectorListener("click", "[data-slider-connect]", function(event, target) {
		event.preventDefault();
		let slides = target.parentNode.children;
		let activeIndex = Array.prototype.indexOf.call(slides, target);

		let targetSlider = Slider.get(document.querySelector(target.getAttribute("data-slider-connect")));
		targetSlider.moveTo(activeIndex);

		for (let i = 0; i < slides.length; ++i) {
			let slide = slides[i];
			if (i == activeIndex) {
				slide.classList.add("active");
			}
			else {
				slide.classList.remove("active");
			}
		}
	});

}());